const initialState = {
    searchQuery: {},
    playlistSearchQuery: {},
    milestoneSearchQuery: {},
    loading: null,
    artistStatsBySource: {},
    artistChartStatsBySource: {},
    platformStatsBySource: {},
    platformChartStatsBySource: {},
    searchTrackList: [],
    trackStats: {},
    trackStatsForMap:{},
    trackChartStats: {},
    milestoneActivities: {},
    playlistActivities: {},
    radioMilestonesData: {},
    radioData: {},
    radioTrackStats: {},
    radioGeoStats:{},
    audienceDetails: {},
    geoDetails: {},
    trackActivities: {},
};

const dataAnalystReducers = (state = initialState, action) => {
    switch (action.type) {
        case 'STARTARTISTBYSOURCE':
            return {
                ...state,
                loading: true,
            };
        case 'ARTISTBYSOURCEFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTPLATFORMBYSOURCE':
            return {
                ...state,
                loading: true,
            };
        case 'PLATFORMDATAFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'SEARCHTRACK':
            return {
                ...state,
                loading: true,
            };
        case 'SEARCHTRACKFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTTRACKS':
            return {
                ...state,
                loading: true,
            };
        case 'TRACKSTATSFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTAUDIENCEDETAILS':
            return {
                ...state,
                loading: true,
            };
        case 'AUDIENCEDETAILSFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTGEODETAILS':
            return {
                ...state,
                loading: true,
            };
        case 'GEODETAILSFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTMILESTONEACTIVITIES':
            return {
                ...state,
                loading: true,
            };
        case 'MILESTONEACTIVITIESFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTTRACKACTIVITIES':
            return {
                ...state,
                loading: true,
            };
        case 'TRACKACTIVITIESFAIL':
            return {
                ...state,
                loading: null,
                failedTrackActivities: action.value
            };
        case 'STARTRADIOMILESTONES':
            return {
                ...state,
                loading: true,
            };
        case 'RADIOMILESTONESFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'STARTRADIOTRACKSTATS':
            return {
                ...state,
                loading: true,
            };
        case 'RADIOTRACKSTATSFAIL':
            return {
                ...state,
                loading: null,
            };
        case 'GETARTISTSTATSBYSOURCE':
            if (JSON.stringify(state.artistStatsBySource) === JSON.stringify(action.stats)) {
                return state;
            }
            return {
                ...state,
                loading: null,
                artistStatsBySource: action.stats,
            };
        case 'GETARTISTCHARTSTATSBYSOURCE':
            return {
                ...state,
                artistChartStatsBySource: action.stats,
            };
        case 'PLATFORMSTATSBYSOURCE':
            return {
                ...state,
                platformStatsBySource: action.stats,
            };
        case 'PLATFORMCHARTSBYSOURCE':
            return {
                ...state,
                platformChartStatsBySource: action.stats,
            };
        case 'ALLTRACKS':
            return {
                ...state,
                allTracks: action.tracks,
            };
        case 'TRACKSTATS':
            return {
                ...state,
                trackStats: action.stats,
            };
        case 'TRACKSTATSFORMAP':
            return {
                ...state,
                trackStatsForMap: action.stats,
            };
        case 'TRACKCHARTS':
            return {
                ...state,
                trackChartStats: action.stats,
            };
        case 'MILESTONEDATA': {
            // action.stats expected to be { data: [], offset, nextOffset, limit, hasMore }
            const incoming = action.stats || {};
            const existing = state.milestoneActivities || {};
            const existingData = Array.isArray(existing?.data) ? existing.data : (Array.isArray(existing) ? existing : []);
            const incomingData = Array.isArray(incoming?.data) ? incoming.data : (Array.isArray(incoming) ? incoming : []);

            let mergedData = incomingData;
            // If this is a subsequent page, append
            if (existingData.length > 0 && incoming.offset && incoming.offset > 0) {
                mergedData = [...existingData, ...incomingData];
            }

            return {
                ...state,
                milestoneActivities: {
                    data: mergedData,
                    offset: incoming.offset ?? null,
                    nextOffset: incoming.nextOffset ?? null,
                    limit: incoming.limit ?? null,
                    hasMore: incoming.hasMore ?? false,
                },
            };
        }
        case 'PLAYLISTDATA': {
            const incoming = action.stats || {};
            const existing = state.playlistActivities || {};
            const existingData = Array.isArray(existing?.data) ? existing.data : (Array.isArray(existing) ? existing : []);
            const incomingData = Array.isArray(incoming?.data) ? incoming.data : (Array.isArray(incoming) ? incoming : []);

            let mergedData = incomingData;
            if (existingData.length > 0 && incoming.offset && incoming.offset > 0) {
                mergedData = [...existingData, ...incomingData];
            }

            return {
                ...state,
                playlistActivities: {
                    data: mergedData,
                    offset: incoming.offset ?? null,
                    nextOffset: incoming.nextOffset ?? null,
                    limit: incoming.limit ?? null,
                    hasMore: incoming.hasMore ?? false,
                },
            };
        }
        case 'RADIOMILESTONESDATA':
            {
                const incoming = action.stats || {};
                const existing = state.radioMilestonesData || {};
                const existingData = Array.isArray(existing?.data) ? existing.data : (Array.isArray(existing) ? existing : []);
                const incomingData = Array.isArray(incoming?.data) ? incoming.data : (Array.isArray(incoming) ? incoming : []);

                // Only append pages when the scope matches (both 'radio' or both 'track') and offset > 0
                let mergedData = incomingData;
                const existingScope = existing?.scope;
                const incomingScope = incoming?.scope;
                if (
                    existingData.length > 0 &&
                    incoming.offset &&
                    incoming.offset > 0 &&
                    existingScope &&
                    incomingScope &&
                    existingScope === incomingScope
                ) {
                    mergedData = [...existingData, ...incomingData];
                }

                return {
                    ...state,
                    radioMilestonesData: {
                        data: mergedData,
                        offset: incoming.offset ?? null,
                        nextOffset: incoming.nextOffset ?? null,
                        limit: incoming.limit ?? null,
                        hasMore: incoming.hasMore ?? false,
                        scope: incomingScope ?? null,
                    }
                };
            }
        case 'RADIODATA':
            return {
                ...state,
                radioData: action.stats
            };
        case 'RADIOTRACKSTATS':
            return {
                ...state,
                radioTrackStats: action.stats
            };
        case 'RADIOTRACKCHARTSTATS':
            return {
                ...state,
                radioTrackChartStats: action.stats
            };
        case 'RADIOGEOSTATS':
            return {
                ...state,
                radioGeoStats: action.stats
            };
        case 'AUDEINCEDATA':
            return {
                ...state,
                audienceDetails: action.stats
            };
        case 'GEODATA':
            return {
                ...state,
                geoDetails: action.stats
            };
        case 'TRACKACTIVITIES':
            return {
                ...state,
                trackActivities: action.stats
            };
        // case 'SEARCHQUERY':
        //     return {
        //         ...state,
        //         searchQuery: action.queryDetails,
        //     };
        case 'SEARCHQUERY':
            return {
                ...state,
                [action.queryType]: action.queryDetails, // dynamic key update
            };
        case 'CLEAR_SEARCH_QUERY':
            return {
                ...state,
                searchQuery: null,
            };
        default:
            return state;
    }
};

export default dataAnalystReducers;
